import { motion } from 'framer-motion';

export const OpenInTelegramScreen: React.FC = () => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center px-4"
      style={{ background: '#0B0B0E' }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
        className="max-w-md w-full"
      >
        <div
          className="rounded-3xl p-8 text-center"
          style={{
            background: 'linear-gradient(160deg, #0F0F13 0%, #0C0C0F 45%, #0A0A0D 100%)',
            border: '1px solid rgba(255,255,255,0.08)',
            boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.06), inset 0 -3px 10px rgba(0,0,0,0.45), 0 10px 30px rgba(0,0,0,0.38)'
          }}
        >
          <div className="mb-6">
            <div 
              className="w-20 h-20 mx-auto mb-4 rounded-2xl flex items-center justify-center"
              style={{
                background: 'linear-gradient(145deg, #111116, #0C0C0F)',
                boxShadow: 'inset 0 1px 2px rgba(255,255,255,0.08), inset 0 -2px 6px rgba(0,0,0,0.4), 0 10px 26px rgba(0,0,0,0.35)',
                border: '1px solid rgba(255,255,255,0.1)'
              }}
            >
              <svg 
                width="40" 
                height="40" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="1.5"
                className="text-white/70"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </div>
            <h2 
              className="text-xl font-semibold mb-3"
              style={{ color: 'rgba(255,255,255,0.9)' }}
            >
              Откройте в Telegram
            </h2>
            <p 
              className="text-sm leading-relaxed mb-6"
              style={{ color: 'rgba(255,255,255,0.6)' }}
            >
              Это приложение работает только внутри Telegram Mini App. Откройте бота для доступа ко всем функциям.
            </p>
          </div>

          <a
            href="https://t.me/headman_salon"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full py-3 px-6 rounded-xl text-sm font-medium transition-all duration-200"
            style={{
              background: 'linear-gradient(145deg, #0E0E0E, #141414)',
              color: 'rgba(255,255,255,0.9)',
              border: '1px solid rgba(255,255,255,0.12)',
              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04), inset 0 -2px 8px rgba(0,0,0,0.6), 0 8px 20px rgba(0,0,0,0.5)',
              textDecoration: 'none'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.01)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Открыть Headman в Telegram
          </a>
        </div>
      </motion.div>
    </div>
  );
};
